import { appEventGTag } from "../event";

export const event = (filterMessage: string) => {
    appEventGTag({
        page: "exploreProviders",
        eventName: "filter",
        eventLocationType: "filter_input",
        eventLocationLabel: `filter_input`,

        filterOptions: filterMessage,
        eventLabel: `Filter use`
    });
};
